import React from "react";
import ChegadaAveiro from "../../components/ChegadaAveiro";
import Submenu from "../../components/Submenu/chegada_aveiro.js";
import CreateBTN from "../../components/CreateBTN";
import CheckList_Icon from "../../imgs/Icons/checklist_icon.svg";
import { withNamespaces } from 'react-i18next';

// eslint-disable-next-line import/no-anonymous-default-export
const ChegadaAveiro_index = ({t}) => { 
  return (
    <>
      <div id="start" className="fantasmaAncora"></div>
      <div id="main">
        <Submenu />
        <CreateBTN link='/todolist' icon={CheckList_Icon} iconAlt={t('moduleBotoes:B3.Alt')} btnName={t('moduleBotoes:B3.B')} />
        <ChegadaAveiro />
      </div>
    </>
  );
};

export default withNamespaces() (ChegadaAveiro_index);